import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { touchForm } from '../../shared/form-helpers';
import { NgForm } from '@angular/forms';
import { FirebaseService } from '../../services/firebase.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public email: string;

  public linkSent = false;

  constructor(
    private firebaseService: FirebaseService
  ) { }

  public ngOnInit(): void {
  }

  public async sendResetLink(form: NgForm): Promise<void> {
    touchForm(form);

    if (form.invalid) {
      return;
    }

    await this.firebaseService.auth.sendPasswordResetEmail(this.email);
    this.linkSent = true;
  }

}
